import { createWalker } from './create.js';
import config from '../syntax/config/walker.js';

export default createWalker(config);
